import styled from 'styled-components';
import { Theme } from '@veneer/theme';

export const Background = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $veneerTheme }) => $veneerTheme.layout.size6};
  @media (max-width: 575px) {
    & h1 {
      font-size: ${({ $veneerTheme }) => $veneerTheme.typography.size7};
    }
  }
`;

export const Message = styled.p<{ $veneerTheme: Theme }>`
  max-width: 100%;
  word-wrap: break-word;
`;
